import Login from "pages/Auth/Login.js";
import UserDetails from "pages/UserManagement/UserDetails";
import JobsListing from "pages/Jobs/JobsListing";
import JobDetails from "pages/Jobs/JobDetails";
import { ROLES } from "components/Common/constants";
import UserListing from "pages/UserManagement/UserListing";
import { WORK_ORDER } from "components/Common/constants";
import QuotationListing from "pages/Quotation/QuotationListing";
import QuotataionDetails from "pages/Quotation/QuotataionDetails";
import SignUp from "pages/Auth/SignUp";

const routes = [
  {
    path: "/user",
    name: "Users",
    rtlName: "لوحة القيادة",
    icon: "fa fa-users text-left",
    component: <UserListing />,
    layout: "/customer",
    show: true,
    roles: [ROLES.CUSTOMER],
  },

  {
    path: "/user/:id/details",
    name: "User Detail",
    rtlName: "لوحة القيادة",
    icon: "fa fa-users text-left",
    component: <UserDetails />,
    layout: "/customer",
    show: false,
    roles: [ROLES.CUSTOMER],
  },
  {
    path: "/login",
    name: "Login",
    rtlName: "منتجات",
    icon: "tim-icons icon-bag-16",
    component: <Login />,
    layout: "/auth",
    show: false,
    roles: [ROLES.CUSTOMER],
  },
  // {
  //   path: "/register",
  //   name: "Register",
  //   rtlName: "منتجات",
  //   icon: "tim-icons icon-bag-16",
  //   component: <SignUp />,
  //   layout: "/auth",
  //   show: false,
  //   roles: [ROLES.CUSTOMER],
  // },
  {
    path: "/jobs",
    name: `${WORK_ORDER} Requests`,
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-bullet-list-67",
    component: <JobsListing />,
    layout: "/customer",
    show: true,
    roles: [ROLES.CUSTOMER],
  },
  {
    path: "/jobs/:id/details",
    name: `${WORK_ORDER} Requests`,
    rtlName: "لوحة القيادة",
    icon: "tim-icons icon-bullet-list-67",
    component: <JobDetails />,
    layout: "/customer",
    show: false,
    roles: [ROLES.CUSTOMER],
  },
  {
    path: "/quotations",
    name: "Quotations",
    rtlName: "لوحة القيادة",
    icon: "fa fa-file-text text-left",
    component: <QuotationListing />,
    layout: "/customer",
    show: true,
    roles: [ROLES.CUSTOMER],
  },
  {
    path: "/quotations/:id/details",
    name: "Quotations",
    rtlName: "لوحة القيادة",
    icon: "fa fa-file-text text-left",
    component: <QuotataionDetails />,
    layout: "/customer",
    show: false,
    roles: [ROLES.CUSTOMER],
  },
];

export default routes;
